<template>
  <div class="page-register">
    <div class="top-line">
      <div class="small-button" @click="toBack()">返回</div>
      <span class="title">账号注册</span>
    </div>
    <div v-if="type == 0" class="type">
      <div class="type-title">请选择注册的账号类型</div>
      <div class="type-list">
        <div class="type-item" @click="chooseType(1)">
          <img class="type-img" src="../../../images/teacher.png" alt="" />
          <div class="type-name">老师账号</div>
          <div class="type-des">需关联已注册的幼儿园</div>
        </div>
        <!-- <div class="type-item" @click="chooseType(2)">
          <img class="type-img" src="../../../images/school.png" alt="" />
          <div class="type-name">幼儿园账号</div>
          <div class="type-des">
          </div>
        </div> -->
      </div>
    </div>
    <div v-if="type > 0" class="content">
      <div class="content-title">
        {{ type == '1' ? '老师账号注册' : '幼儿园账号注册' }}
      </div>
      <div class="steps" v-if="step == 1 || step == 2">
        <div class="step">
          <div :class="{ 'step-num': true, 'step-num-cur': step == 1 }">1</div>
          <div :class="{ 'step-des': true, 'step-des-cur': step == 1 }">
            输入手机号
          </div>
        </div>
        <div class="step-line"></div>
        <div class="step">
          <div :class="{ 'step-num': true, 'step-num-cur': step == 2 }">2</div>
          <div :class="{ 'step-des': true, 'step-des-cur': step == 2 }">
            设置账号信息
          </div>
        </div>
      </div>
      <div v-if="step == 1">
        <div class="register-line register-line2">
          <div class="line-title">手机号</div>
          <el-input
            v-model="phone"
            placeholder="请输入您的手机号"
            style="width: 266px"
            @input="inputPhone"
          ></el-input>
          <div v-if="!sendSms && !hasUsed" class="get-code" @click="toSendSms">
            {{ sendFirst ? '获取验证码' : '重新获取' }}
          </div>
          <div v-if="sendSms && !hasUsed" class="get-code">{{ smsTimes }}s</div>
          <div v-if="hasUsed" class="phone-used">
            该手机号已注册过账号，请前往登录或输入未注册的手机号
          </div>
        </div>
        <div class="register-line register-line2">
          <div class="line-title">验证码</div>
          <el-input
            v-model="code"
            placeholder="请输入短信验证码"
            style="width: 266px"
          ></el-input>
        </div>
        <div class="next" @click="next()">下一步</div>
      </div>
      <div v-if="step == 2 && type == 2">
        <div class="register-line register-line2">
          <!-- <div class="register-line register-line2" style="margin-bottom: 57px"> -->
          <!-- <div class="password-tips school-tips">
            没有找到您要注册的幼儿园？请点击
            <span
              style="color: #27b2fe; cursor: pointer"
              @click="toShowCustomer"
              >平台管理员</span
            >
            平台管理
          </div> -->
          <div class="line-title line-title3">幼儿园所在地区</div>
          <el-select
            v-model="provinceValue"
            clearable
            placeholder="省"
            style="margin-right: 20px; width: 170px"
            @change="selectProvince(2)"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.province_id"
              :label="item.name"
              :value="item.province_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="cityValue"
            clearable
            placeholder="市"
            style="margin-right: 20px; width: 170px"
            @change="selectCity(2)"
          >
            <el-option
              v-for="item in cityList"
              :key="item.city_id"
              :label="item.name"
              :value="item.city_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="areaValue"
            clearable
            placeholder="区/县"
            style="margin-right: 20px; width: 170px"
            @change="selectArea(2)"
          >
            <el-option
              v-for="item in areaList"
              :key="item.area_id"
              :label="item.name"
              :value="item.area_id"
            >
            </el-option>
          </el-select>
          <!-- <el-select
            v-model="schoolValue"
            clearable
            placeholder="幼儿园"
            style="margin-right: 20px; width: 170px"
            @change="selectSchool(2)"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
          <!-- <el-input
            v-model="schoolValue"
            placeholder="请填写幼儿园名称"
            style="width: 266px"
            @input="(e) => inputStorage(e, 2, 'schoolValue')"
          ></el-input> -->
        </div>

        <div class="register-line register-line2">
          <div class="line-title line-title3">注册幼儿园名称</div>
          <el-input
            v-model="schoolValue"
            placeholder="请填写幼儿园名称"
            style="width: 266px"
            @input="(e) => inputStorage(e, 2, 'schoolValue')"
          ></el-input>
        </div>

        <div class="register-line">
          <!-- :style="{ height: yyzzFileName ? '120px' : '90px' }" -->
          <div class="line-title line-title3">
            <!-- 上传主体资质 -->
            上传注册申请书
          </div>
          <div>
            <div class="upload-box">
              <el-image
                v-if="yyzzFileImg"
                class="upload-img2"
                :src="yyzzFileImg"
                :preview-src-list="[yyzzFileImg]"
              >
              </el-image>
              <div v-if="yyzzFileName" class="yyzz-name">
                {{ yyzzFileName }}
              </div>
              <div class="upload">
                <!-- <div class="upload-line1"></div>
                <div class="upload-line2"></div>
                <img
                  class="upload-img"
                  v-if="yyzzFileImg"
                  :src="yyzzFileImg"
                  alt=""
                /> -->
                {{ yyzzFileImg ? '+重新上传' : '+点击上传' }}
                <input
                  class="upload-abs"
                  type="file"
                  accept="image/*"
                  @change="uploadFile"
                />
                <!-- <div class="upload-tips">
                  请上传幼儿园工商营业执照图片
                </div> -->
              </div>
            </div>
            <div class="upload-tips2">
              <div>
                请点击下载
                <span
                  style="color: #27b2fe; cursor: pointer"
                  @click="toDownloadApplication"
                  >《注册申请书》</span
                >
                ，填写信息并盖上幼儿园公章后扫描或拍照上传。
              </div>
              <div>可上传文件类型为png，jpg，jpeg。</div>
            </div>
          </div>
        </div>
        <div class="register-line register-line2" style="margin-bottom: 57px">
          <div class="line-title line-title3">密码</div>
          <el-input
            v-model="password"
            placeholder="请设置密码"
            style="width: 266px"
            show-password
            @blur="onPassWordBlur"
            @input="(e) => inputStorage(e, 2, 'password')"
          ></el-input>
          <div class="password-tips school-tips">
            密码必须包含字母、数字和英文符号，长度至少8位，区分大小写
          </div>
        </div>
        <div class="register-line register-line2">
          <div class="line-title line-title3">确认密码</div>
          <el-input
            v-model="password2"
            placeholder="请再次输入密码"
            style="width: 266px"
            show-password
            @input="(e) => inputStorage(e, 2, 'password2')"
          ></el-input>
        </div>
        <div class="agreement agreement2" style="margin-top: 40px">
          <el-checkbox v-model="checked"></el-checkbox>
          我已阅读并同意
          <span class="agreement-btn" @click="toDownloadAgreement(1)"
            >《用户协议》</span
          >
          和
          <span class="agreement-btn" @click="toDownloadAgreement(2)"
            >《隐私政策》</span
          >
        </div>
        <div class="submit submit2" @click="submit()">提交注册申请</div>
      </div>

      <div v-if="step == 2 && type == 1">
        <div class="register-line register-line2">
          <div class="line-title line-title2">姓名</div>
          <el-input
            v-model="name"
            placeholder="请输入您的姓名"
            style="width: 266px"
            @input="(e) => inputStorage(e, 1, 'name')"
          ></el-input>
        </div>
        <div class="register-line register-line2" style="margin-bottom: 57px">
          <div class="line-title line-title2">密码</div>
          <el-input
            v-model="password"
            placeholder="请设置密码"
            style="width: 266px"
            show-password
            @blur="onPassWordBlur"
            @input="(e) => inputStorage(e, 1, 'password')"
          ></el-input>
          <div class="password-tips">
            密码必须包含字母、数字和英文符号，长度至少8位，区分大小写
          </div>
        </div>
        <div class="register-line register-line2">
          <div class="line-title line-title2">确认密码</div>
          <el-input
            v-model="password2"
            placeholder="请再次输入密码"
            style="width: 266px"
            show-password
            @input="(e) => inputStorage(e, 1, 'password2')"
          ></el-input>
        </div>
        <div class="register-line register-line2">
          <div class="password-tips">
            注册申请将发送给关联的幼儿园账号，审核通过即注册成功，请留意短信通知。
          </div>
          <div class="password-tips teacher-tips">
            如找不到您所在的幼儿园，请联系幼儿园管理员先注册幼儿园账号。
          </div>
          <div class="line-title line-title2">关联幼儿园</div>
          <el-select
            v-model="provinceValue"
            clearable
            placeholder="省"
            style="margin-right: 20px; width: 170px"
            @change="selectProvince(1)"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.province_id"
              :label="item.name"
              :value="item.province_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="cityValue"
            clearable
            placeholder="市"
            style="margin-right: 20px; width: 170px"
            @change="selectCity(1)"
          >
            <el-option
              v-for="item in cityList"
              :key="item.city_id"
              :label="item.name"
              :value="item.city_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="areaValue"
            clearable
            placeholder="区/县"
            style="margin-right: 20px; width: 170px"
            @change="selectArea(1)"
          >
            <el-option
              v-for="item in areaList"
              :key="item.area_id"
              :label="item.name"
              :value="item.area_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="schoolValue"
            clearable
            placeholder="幼儿园"
            style="margin-right: 20px; width: 280px"
            @change="selectSchool(1)"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="agreement">
          <el-checkbox v-model="checked"></el-checkbox>
          我已阅读并同意
          <span class="agreement-btn" @click="toDownloadAgreement(1)"
            >《用户协议》</span
          >
          和
          <span class="agreement-btn" @click="toDownloadAgreement(2)"
            >《隐私政策》</span
          >
        </div>
        <div class="submit" @click="submit()">提交注册申请</div>
      </div>
      <div v-if="step == 3" class="success">
        <img
          class="success-icon"
          src="../../../images/uploadSuccess.png"
          alt=""
        />
        <div class="success-title">
          {{ type == 1 ? '注册申请提交成功！' : '您的注册申请正在审核中' }}
        </div>
        <div class="success-des">
          {{
            type == 1
              ? '幼儿园管理员审核通过后您会收到短信通知，请留意。'
              : '您的注册申请正在审核，平台审核通过后您会收到短信通知，请留意。'
          }}
        </div>
        <div class="success-table">
          <div v-if="type == 1" class="success-table-line">
            <div class="success-table-name">姓名</div>
            <div class="success-table-content">{{ name }}</div>
          </div>
          <div v-if="type == 2" class="success-table-line">
            <div class="success-table-name">幼儿园</div>
            <div class="success-table-content">{{ schoolName }}</div>
          </div>
          <div class="success-table-line">
            <div class="success-table-name">手机号</div>
            <div class="success-table-content">{{ phone }}</div>
          </div>
          <div v-if="type == 1" class="success-table-line">
            <div class="success-table-name">关联幼儿园</div>
            <div class="success-table-content">{{ schoolName }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showCustomer" class="mask">
      <div class="customer">
        <div class="close" @click="closeCustomer"></div>
        <div class="customer-title">微信扫描二维码联系平台管理员</div>
        <img class="customer-img" src="../../../images/zls.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  send_sms,
  sms_auth,
  check_register_sms,
  province,
  city,
  area,
  yey,
  school,
  register,
  upload,
  authUpload,
  find_info_by_phone,
  check_phone_status
} from '@/api/api.js'
export default {
  name: 'Register',
  data: () => ({
    type: 0, // 1-老师 2-幼儿园
    step: 0,

    phone: '', // 手机号
    code: '', // 验证码
    sendSms: false, // 正在发送验证码
    sendFirst: true, // 第一次发送验证码
    smsTimes: 0, // 验证码倒计时
    sendInterval: null, // 验证码计时器
    hasUsed: false, // 手机号被注册

    provinceList: [], // 省
    provinceValue: '',
    cityList: [], // 市
    cityValue: '',
    areaList: [], // 区
    areaValue: '',
    schoolList: [], // 学校
    schoolValue: '',
    schoolName: '',

    name: '', // 姓名
    password: '', // 密码
    password2: '', // 确认密码
    yyzzFile: {}, // 营业执照文件
    yyzzFileImg: '', // 营业执照图片
    yyzzFileName: '', // 营业执照文件名
    showCustomer: false,

    checked: '', // 勾选阅读

    hasZCPhone: false,
    phoneStatus: 0, // 0未注册(审核不通过) 1注册了未审核 2审核成功
    hasClick: false, //点击过输入框
  }),

  async mounted() {
    console.log('query', this.$route.query)
    if (this.$route.query.zcPhone) {
      // 有注册信息，待审核状态
      this.hasZCPhone = true
      this.getUserInfo(this.$route.query.zcPhone)
    }

    province().then((res) => {
      console.log('province', res)
      this.provinceList = res.data.data
    })
  },
  methods: {
    async getUserInfo(phone) {
      let findInfoRes = await find_info_by_phone({
        phone: phone,
        auth: 'teacher'
      })
      console.log('findInfoRes', findInfoRes)
      let info = findInfoRes.data.data
      this.type = info.role == 'teacher' ? 1 : 2
      this.step = 3
      this.phone = phone
      this.name = info.nick_name
      this.schoolName = info.school.name
    },
    toBack() {
      if (this.type > 0 && !this.hasZCPhone) {
        this.type = 0
        this.name = ''
        this.phone = ''
        this.code = ''
        this.sendSms = false
        this.sendFirst = true
        this.smsTimes = 0
        this.password = ''
        this.password2 = ''
        this.yyzzFile = {}
        this.yyzzFileImg = ''
        this.yyzzFileName = ''
        this.showCustomer = false
        this.provinceValue = ''
        this.cityValue = ''
        this.areaValue = ''
        this.schoolValue = ''
        this.cityList = []
        this.areaList = []
        this.schoolList = []
        this.hasUsed = false
        clearInterval(this.sendInterval)
        return
      }
      this.$router.back()
    },
    chooseType(type) {
      this.step = 1
      this.type = type
    },
    selectProvince(type) {
      this.inputStorage(this.provinceValue, type, 'provinceValue')
      console.log('provinceValue', this.provinceValue)
      city({ province_id: this.provinceValue }).then((res) => {
        console.log('city', res)
        this.cityList = res.data.data
        this.cityValue = ''
        this.areaList = []
        this.areaValue = ''
        this.schoolList = []
        this.schoolValue = ''
      })
    },
    selectCity(type) {
      this.inputStorage(this.cityValue, type, 'cityValue')
      console.log('cityValue', this.cityValue)
      area({ city_id: this.cityValue }).then((res) => {
        console.log('area', res)
        this.areaList = res.data.data
        this.areaValue = ''
        this.schoolList = []
        this.schoolValue = ''
      })
    },
    async selectArea(type) {
      this.inputStorage(this.areaValue, type, 'areaValue')
      console.log('areaValue', this.areaValue)
      let res = null
      if (this.type == 1) {
        res = await school({ area_id: this.areaValue })
      } else {
        res = await yey({ area_id: this.areaValue })
      }
      console.log('yey', res)
      this.schoolList = res.data.data
      this.schoolValue = ''
    },
    selectSchool(type) {
      this.inputStorage(this.schoolValue, type, 'schoolValue')
      console.log('schoolValue', this.schoolValue)
      for (let i = 0; i < this.schoolList.length; i++) {
        if (this.schoolList[i].id == this.schoolValue) {
          this.schoolName = this.schoolList[i].name
          break
        }
      }
    },

    uploadFile(e) {
      console.log('file', e.target.files)
      this.yyzzFile = e.target.files
      let file = e.target.files[0]
      var _URL = window.URL || window.webkitURL
      this.yyzzFile = {
        type: 'image',
        url: _URL.createObjectURL(file),
        file: file,
        name: file.name,
      }
      this.yyzzFileImg = this.yyzzFile.url
      this.yyzzFileName = file.name
    },
    async submit() {
      // this.step = 3
      // this.schoolName = this.schoolValue
      // // localStorage.removeItem('yey-registerInfo1')
      // // localStorage.removeItem('yey-registerInfo2')
      // return

      if (this.type == 1 && !this.name) {
        this.$message.error('请先填写姓名')
        return
      }
      if (this.password !== this.password2) {
        this.$message.error('两次密码输入不一致')
        return
      }
      if (this.password.length < 8) {
        this.$message.error('密码最短为8位')
        return
      }
      let reg = /(?=.*[a-zA-z])(?=.*[0-9])(?=.*[!@#$%^&*,.;:])/g
      if(!reg.test(this.password)) {
        this.$message.error('密码需包含字母、数字和特殊符号（!@#$%^&*,.;:）！')
        return
      }
      if (!this.schoolValue) {
        this.$message.error('请先选择幼儿园')
        return
      }
      if (!this.checked) {
        this.$message.error('请先阅读并同意协议')
        return
      }
      if (this.type == 2 && !this.yyzzFile.file) {
        this.$message.error('请先上传注册申请书')
        return
      }

      let data = {
        role: this.type == 1 ? 'teacher' : 'school',
        // nick_name: this.type == 1 ? this.name : this.schoolName,
        nick_name: this.type == 1 ? this.name : this.schoolValue,
        password: this.password,
        phone: this.phone,
        province_id: this.provinceValue,
        city_id: this.cityValue,
        area_id: this.areaValue,
        // school_id: this.schoolValue,
        user_name: this.phone,
      }

      if (this.type == 2) {
        this.schoolName = this.schoolValue
        let formData = new FormData()
        formData.append('file', this.yyzzFile.file)
        let fileRes = await authUpload(formData)
        console.log('fileRes', fileRes)
        let ossOrigin = 'https://ms-yey.oss-cn-shanghai.aliyuncs.com/'
        data.certificate = `${ossOrigin}${fileRes.data.data.url}`
      } else {
        data.school_id = this.schoolValue
      }
      console.log('submit', data)
      // return

      // this.step = 3
      // return

      register(data).then((res) => {
        console.log('register', res)
        if (res.data.code == -1) {
          this.$message.error(res.data.msg)
          return
        }
        this.step = 3
        localStorage.removeItem('yey-registerInfo1')
        localStorage.removeItem('yey-registerInfo2')
      })
    },
    onPassWordBlur(e) {
      if(!this.hasClick) {
        this.hasClick = true
        return
      }
      let reg = /(?=.*[a-zA-z])(?=.*[0-9])(?=.*[!@#$%^&*,.;:])/g
      if(this.password.length == 0){
        return
      }
      if(!reg.test(this.password)) {
        this.$message.error('密码需包含字母、数字和特殊符号（!@#$%^&*,.;:）！')
      }
    },

    inputPhone() {
      console.log('inputPhone')
      this.hasUsed = false
    },
    async toSendSms() {
      console.log('phone', this.phone)
      if (!this.phone) {
        this.$message.error('请先填写手机号')
        return
      }
      if (this.sendSms) {
        return
      }

      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.phone)) {
        this.$message.error('请填写正确手机号')
        return
      }
      let phoneStatus = 0 // 0未注册(审核不通过) 1注册了未审核 2审核成功
      let phoneRes = await check_phone_status({ phone: this.phone, role: this.type == 1 ? 'teacher' : 'school' })
      console.log('phoneStatus', phoneRes)
      if (phoneRes.data.data == '手机号已注册，已审核') {
        phoneStatus = 2
        this.hasUsed = true
        return
      }
      if (phoneRes.data.data == '手机号已注册，待审核') {
        phoneStatus = 1
        // this.$router.push({ path: '/register', query: { zcPhone: this.phone } })
      }

      // if (phoneStatus == 0) {
      //   this.$message.error('手机号未注册')
      //   return
      // }
      this.phoneStatus = phoneStatus

      let res = await send_sms({ phone: this.phone })
      console.log('send_sms', res)
      if (res.data.code == -1) {
        if (res.data.msg == '触发分钟级流控Permits:1') {
          this.$message.error('验证码获取频繁，请于1分钟后再次尝试')
          return
        }
        if (res.data.msg == '触发小时级流控Permits:5') {
          this.$message.error('验证码获取频繁，请于1小时后再次尝试')
          return
        }
        if (res.data.msg == '触发天级流控Permits:10') {
          this.$message.error('验证码获取频繁，请于1天后再次尝试')
          return
        }
        this.$message.error(res.data.msg)
        return
      }
      this.sendSms = true
      this.sendFirst = false
      this.smsTimes = 59
      clearInterval(this.sendInterval)
      this.sendInterval = setInterval(() => {
        this.smsTimes = this.smsTimes - 1
        if (this.smsTimes < 1) {
          this.sendSms = false
          clearInterval(this.sendInterval)
        }
      }, 1000)
    },
    next() {
      // this.step = 2
      // // this.initStorage()
      // return

      // 如果是注册过学校，添加老师角色，单独处理
      if(this.addRole) {
        check_register_sms({ phone: this.phone, v_code: this.code }).then(
          (res) => {
            console.log('sms_auth', res)
            if (res.data.code == -1) {
              this.$message.error(res.data.msg)
              return
            }
            if (this.phoneStatus == 1) {
              this.getUserInfo(this.phone)
            } else {
              this.step = 2
              this.initStorage()
            }
          }
        )
        return
      }
      if (!this.phone) {
        this.$message.error('请先填写手机号')
        return
      }
      if (!this.code) {
        this.$message.error('请先填写验证码')
        return
      }

      check_register_sms({ phone: this.phone, v_code: this.code }).then(
        (res) => {
          console.log('sms_auth', res)
          if (res.data.code == -1) {
            this.$message.error(res.data.msg)
            return
          }
          if (this.phoneStatus == 1) {
            this.getUserInfo(this.phone)
          } else {
            this.step = 2
            this.initStorage()
          }
        }
      )
    },
    async initStorage() {
      let registerInfo = {}
      if (this.type == 1) {
        // 老师
        registerInfo =
          JSON.parse(localStorage.getItem('yey-registerInfo1')) || {}
      } else {
        // 学校
        registerInfo =
          JSON.parse(localStorage.getItem('yey-registerInfo2')) || {}
      }
      console.log('registerInfo', registerInfo)
      this.name = registerInfo.name || ''
      this.password = registerInfo.password || ''
      this.password2 = registerInfo.password2 || ''
      if (registerInfo.provinceValue) {
        this.provinceValue = registerInfo.provinceValue
        let res = await city({ province_id: this.provinceValue })
        console.log('city', res)
        this.cityList = res.data.data
        this.cityValue = ''
        this.areaList = []
        this.areaValue = ''
        this.schoolList = []
        this.schoolValue = ''
      }
      if (registerInfo.cityValue) {
        this.cityValue = registerInfo.cityValue
        let res = await area({ city_id: this.cityValue })
        console.log('area', res)
        this.areaList = res.data.data
        this.areaValue = ''
        this.schoolList = []
        this.schoolValue = ''
      }
      if (registerInfo.areaValue) {
        this.areaValue = registerInfo.areaValue
        let res = await school({ area_id: this.areaValue })
        console.log('yey', res)
        this.schoolList = res.data.data
        this.schoolValue = ''
      }
      if (registerInfo.schoolValue) {
        this.schoolValue = registerInfo.schoolValue
      }
    },
    inputStorage(e, role, type) {
      let registerInfo = {}
      if (role == 1) {
        // 老师
        registerInfo =
          JSON.parse(localStorage.getItem('yey-registerInfo1')) || {}
      } else {
        // 学校
        registerInfo =
          JSON.parse(localStorage.getItem('yey-registerInfo2')) || {}
      }
      registerInfo[type] = e
      console.log('registerInfo', registerInfo)
      if (role == 1) {
        localStorage.setItem('yey-registerInfo1', JSON.stringify(registerInfo))
      } else {
        localStorage.setItem('yey-registerInfo2', JSON.stringify(registerInfo))
      }
    },
    toShowCustomer() {
      this.showCustomer = true
    },
    closeCustomer() {
      this.showCustomer = false
    },

    // https://ms-yey.oss-cn-shanghai.aliyuncs.com/webFile/1.pdf
    // https://ms-yey.oss-cn-shanghai.aliyuncs.com/webFile/1.docx
    toDownloadApplication() {
      const x = new XMLHttpRequest()
      x.open(
        'GET',
        'https://ms-yey.oss-cn-shanghai.aliyuncs.com/webFile/1.pdf',
        true
      )
      x.responseType = 'blob'
      x.onload = function (e) {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.target = 'blank'
        a.download = '注册申请书'
        a.click()
        a.remove()
      }
      x.send()
    },
    toDownloadAgreement(type) {
      window.open(
        // `https://yey.mashu.cloud/#/filePreview?url=https://ms-yey.oss-cn-shanghai.aliyuncs.com/webFile/${type}.docx`
        `https://www.yeykcfa.cn/#/filePreview?url=https://ms-yey.oss-cn-shanghai.aliyuncs.com/webFile/xy${type}.pdf`
      )
    },
  },
}
</script>

<style lang="less" scoped>
.page-register {
  height: 100%;
  padding: 0 140px;
  background-color: rgba(#5ccbf7, 0.2);
  background-image: url('../../assets/bottomBg.png');
  background-size: 100% 220px;
  background-position: 0 calc(100vh - 320px);
  background-repeat: no-repeat;
  .top-line {
    display: flex;
    height: 81px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
    color: #4d4d4d;
    margin-left: 20px;
  }
  .type {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    height: calc(100vh - 200px);
    // padding-bottom: 100px;
    // background-color: #ccc;
    box-sizing: border-box;
    .type-title {
      flex-shrink: 0;
      margin-bottom: 80px;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 56px;
      text-align: center;
    }
    .type-list {
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-top: 80px;
      height: 368px;
      .type-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 382px;
        height: 310px;
        // height: 368px;
        margin: 0 106px;
        // padding-top: 35px;
        background: #ffffff;
        border-radius: 40px;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.1s;
        &:hover {
          width: 454px;
          height: 368px;
          margin: 0 70px;
          box-shadow: 0px 0px 100px 0px rgba(49, 152, 194, 0.3);
          .type-img {
            width: 170px;
            height: 170px;
          }
        }
        .type-img {
          width: 138px;
          height: 138px;
        }
        .type-name {
          margin-top: 20px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #285167;
          line-height: 44px;
          text-align: center;
        }
        .type-des {
          height: 36px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #285167;
          line-height: 36px;
          text-align: center;
        }
      }
    }
  }

  .content {
    width: calc(100vw - 250px);
    height: calc(100vh - 248px);
    // max-height: calc(100vh - 248px);
    margin-top: 9px;
    padding-bottom: 30px;
    background-color: #fff;
    // box-sizing: border-box;
    overflow: auto;
    .content-title {
      height: 72px;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #000000;
      line-height: 72px;
      text-align: center;
      background: rgba(39, 178, 254, 0.1);
    }
    .steps {
      display: flex;
      align-items: center;
      height: 152px;
      padding-left: 207px;
      .step {
        display: flex;
        align-items: center;
        height: 34px;
        .step-num {
          width: 34px;
          height: 34px;
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          line-height: 30px;
          text-align: center;
          border: 2px solid #b3b3b3;
          border-radius: 50%;
          box-sizing: border-box;
        }
        .step-num-cur {
          color: #27b2fe;
          background: rgba(39, 178, 254, 0.1);
          border: 2px solid #27b2fe;
        }
        .step-des {
          margin-left: 10px;
          padding-bottom: 4px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
          line-height: 30px;
        }
        .step-des-cur {
          color: #27b2fe;
        }
      }
      .step-line {
        width: 120px;
        height: 2px;
        margin: 0 35px;
        background: #d8d8d8;
      }
    }
  }
  .register-line {
    display: flex;
    // align-items: center;
    // height: 40px;
    // margin: 0 0 30px 207px;
    margin: 0 0 30px 200px;
    .line-title {
      flex-shrink: 0;
      margin-right: 20px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 40px;
    }
    .get-code {
      width: 114px;
      height: 40px;
      margin-left: 30px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #00aeff;
      line-height: 40px;
      text-align: center;
      background: rgba(39, 178, 254, 0.1);
      border-radius: 4px;
      cursor: pointer;
    }
    .phone-used {
      margin-left: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #e12616;
      line-height: 40px;
    }

    .upload {
      position: relative;
      // width: 110px;
      // height: 110px;
      // background: #ffffff;
      // border-radius: 4px;
      // border: 1px solid #d8dce6;
      width: 140px;
      height: 40px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      text-align: center;
      line-height: 40px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d8dce6;
      .upload-line1 {
        position: absolute;
        left: 39px;
        top: 53px;
        width: 32px;
        height: 4px;
        background: #999999;
      }
      .upload-line2 {
        position: absolute;
        left: 53px;
        top: 39px;
        width: 4px;
        height: 32px;
        background: #999999;
      }

      .upload-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 110px;
        height: 110px;
      }
      .upload-abs {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }

      .upload-tips {
        position: absolute;
        width: 300px;
        bottom: -7px;
        left: 130px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
      }
    }
  }

  .upload-box {
    display: flex;
    align-items: flex-end;
    // position: relative;
  }
  .upload-img2 {
    width: 84px;
    // height: 118px;
    margin-right: 10px;
    border: 1px solid #d8dce6;
  }
  .yyzz-name {
    margin-right: 20px;
    color: #606266;
    font-size: 14px;
    line-height: 40px;
    // margin-bottom: 6px;
  }
  .upload-tips2 {
    // position: absolute;
    width: 600px;
    margin-top: 10px;
    bottom: 0;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }
  .line-title2 {
    width: 107px;
    text-align: right;
  }
  .line-title3 {
    // width: 127px;
    width: 147px;
    text-align: right;
  }
  .register-line2 {
    position: relative;
    height: 40px;
    margin-left: 200px;
    .password-tips {
      position: absolute;
      top: 50px;
      left: 127px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
    }
    .teacher-tips {
      top: 70px;
    }
    .school-tips {
      // left: 147px;
      left: 167px;
    }
  }
  .next {
    width: 121px;
    height: 40px;
    margin: 80px 0 0 207px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    background: #27b2fe;
    border-radius: 4px;
    cursor: pointer;
  }
  .agreement {
    margin: 90px 0 0 327px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 34px;
    .agreement-btn {
      color: #27b2fe;
      cursor: pointer;
    }
  }
  .agreement2 {
    // margin-left: 347px;
    margin-left: 367px;
  }
  .submit {
    width: 172px;
    height: 40px;
    margin: 20px 0 0 327px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    background: #27b2fe;
    border-radius: 4px;
    cursor: pointer;
  }
  .submit2 {
    // margin-left: 347px;
    margin-left: 367px;
  }

  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 330px);
    min-height: 450px;
    // padding-top: 117px;
    .success-icon {
      width: 89px;
      height: 94px;
      // background-color: #ccc;
    }
    .success-title {
      margin-top: 19px;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 46px;
    }
    .success-des {
      margin-top: 12px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4d4d4d;
      line-height: 40px;
    }
    .success-table {
      margin-top: 50px;
      border-radius: 10px;
      border: 1px solid #add1f4;
      .success-table-line {
        display: flex;
        align-items: center;
        width: 440px;
        border-bottom: 1px solid #add1f4;
        &:last-child {
          border-bottom: none;
        }
        .success-table-name {
          width: 190px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 56px;
          text-align: center;
          // border-right: 1px solid #add1f4;
        }
        .success-table-content {
          display: flex;
          align-items: center;
          flex-shrink: 1;
          width: 250px;
          min-height: 56px;
          // padding-left: 30px;
          padding: 10px 20px 10px 30px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          word-break: break-all;
          border-left: 1px solid #add1f4;
          box-sizing: border-box;
        }
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(#000, 0.7);
  }
  .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(45deg);
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(-45deg);
    }
  }
  .customer {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 506px;
    height: 324px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    .customer-title {
      padding: 24px 0 16px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 36px;
      text-align: center;
    }
    .customer-img {
      width: 194px;
      height: 194px;
      background-color: ccc;
    }
  }
}
</style>
